import { ChainId } from "@types";
import { abi } from ".";
import type { Address, BasicContractConfig, } from "../types";
import { lookupContract, lookupToken,} from "@bracket/addressbook";



/** get the latest price bracket offers for ethereum */
export const getLatestPrice = ( chain: ChainId, ) => {

	return ( options: { watch?: boolean; } = {}): BasicContractConfig => {
		const address = lookupContract(1, "Pricing");

		if( address ) {

			const result = Object.assign({
				address,
				abi,
				functionName: "getLatestPrice",
				args: [ lookupToken(1, "ETH_USD"), ],
				chainId: 1,
			}, options);

			const log = [
				"--- GET_LATEST_PRICE ---",
				`active chain: ${result.chainId}`,
				`currency: ETH`,
				`contract address: ${result.address}`,
				`functionName: ${result.functionName}`,
				`args:`,
				`\t0 [ETH_USD address]: ${result.args[0]}`,
				"----------",
			];
			// console.log(log.join("\n"));
			return result;
		}
		throw new Error(`chain ${chain} does not have a Pricing contract address`);
	};

}



/** not implemented! */
export const getClaimPrice = ( asset:Address ) => {

	throw new Error("getClaimPrice not implemented");
}

/** not implemented! */
export const setClaimDelta = ( value:BigInt ) => {

	throw new Error("setClaimPrice not implemented");
}
